import React, {FC, useEffect, useState} from 'react';
import '/site/parts/chairman-blog/chairman-blog.scss';
import { IBlog } from '/react4xp/parts/chairman-blog/chairman-blog.type';
import IProps = IBlog.IProps;
import Button from '/react4xp/mixins/ui/button/button';
import {getImgUrl} from "/react4xp/parts/service-link-img/actions";

const ChairmanBlog: FC<IProps> = (props: IProps) => {
    const [img, setImg] = useState({});

    useEffect(() => {
        if (props.config.image) {
            getImgUrl(props.config.image).then(
                value => {
                    if (value.data) {
                        setImg({ minHeight: 300, background: `url(${value.data}) 50% 0% / cover no-repeat` });
                    }
                }
            );
        }
    }, []);

    return (
        <div className="chairman-blog">
            <div className="chairman-blog__title">{props.config.nameBlog}</div>
            <div
                className="chairman-blog__img"
                style={img}
            />
            <div className="chairman-blog__name">{props.config.name}</div>
            <div className="chairman-blog__button">
                <Button
                    type="primary"
                    color="gold"
                    onClick={() => open(props.config.link)}
                >
                    {props.config.questionText}
                </Button>
            </div>
        </div>
    );
};

export default ChairmanBlog;
